/**
 *
 * RegisterCompany
 *
 */

import { Flex, SystemStyleObject, useDisclosure } from '@chakra-ui/react';
import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { ROUTES } from 'config/routes';
import { useNavigate } from 'react-router-dom';
import CompanyForm from 'app/components/CompanyForm';
import CustomModal from 'app/components/CustomModal';
import { useCustomToast } from 'hooks/useToast';
import { IRequestCompany, registerCompany } from 'services/http/company';
import { parseErrors, ResponseErrors } from 'utils/parseErrors';

interface RegisterCompanyProps {}

const RegisterCompany = (_props: RegisterCompanyProps) => {
	const styles: Record<string, SystemStyleObject> = {
		container: {
			width: '100%',
			justifyContent: 'center',
			padding: { base: '1rem', md: '3.75rem' },
		},
	};

	const { addToast } = useCustomToast();
	const navigate = useNavigate();
	const { onOpen, onClose, isOpen } = useDisclosure();

	const { mutate: createCompanyMutate, isLoading: isLoadingCreateCompany } = useMutation<
		void,
		AxiosError<ResponseErrors>,
		IRequestCompany
	>(data => registerCompany(data), {
		onSuccess: () => {
			onOpen();
		},
		onError: errors => {
			addToast({
				type: 'error',
				title: 'Erro!',
				description: parseErrors(errors?.response?.data),
			});
		},
	});

	return (
		<>
			<Flex sx={styles.container}>
				<CompanyForm isLoading={isLoadingCreateCompany} onSubmitForm={values => createCompanyMutate(values)} />
			</Flex>

			<CustomModal
				isOpen={isOpen}
				onClose={onClose}
				title="A Unidade foi cadastrada com sucesso!"
				actions={[
					{
						type: 'solid',
						label: 'Voltar à tela de unidades',
						datatestid: 'button--redirect',
						onClick: () => navigate(ROUTES.listCompanies),
					},
				]}
			/>
		</>
	);
};

export default RegisterCompany;
